import React from 'react'

import { Table, Row, Col, Button } from '_zari/core'

import * as Modals from './modals'

const tableHeaderRows = [
  { label: 'CUENTA CONTABLE' },
  { label: 'DH', width: 100 },
  { label: '', width: 60 }
]

const DetallesSection = ({ detalles, dispatch }) => {
  const [mostrarNuevoModal, setMostarNuevoModal] = React.useState(false)
  const [mostrarEditarModal, setMostarEditarModal] = React.useState(false)

  const editarModalDataRef = React.useRef({})

  const clickNuevo = React.useCallback(() => {
    setMostarNuevoModal(true)
  }, [])

  const clickEditar = React.useCallback(
    ({ _idFila }) => {
      const detalle = detalles.find(x => x._idFila === _idFila)
      editarModalDataRef.current = detalle
      setMostarEditarModal(true)
    },
    [detalles]
  )

  const clickEliminar = React.useCallback(
    ({ _idFila }) => {
      dispatch({ type: 'eliminar', payload: { _idFila } })
    },
    [dispatch]
  )

  const tableRowTemplate = React.useCallback(
    row => (
      <Table.Row key={row._idFila}>
        <Table.Cell>{row.cuentaContableInfo || '--'}</Table.Cell>
        <Table.Cell>{row.dh || '--'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item
                key='editar'
                handleClose={handleClose}
                onClick={e => clickEditar({ _idFila: row._idFila })}
              >
                Editar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item
                key='eliminar'
                handleClose={handleClose}
                onClick={e => clickEliminar({ _idFila: row._idFila })}
              >
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEliminar, clickEditar]
  )

  const submitNuevo = React.useCallback(
    data => {
      dispatch({ type: 'agregar', payload: data })
      setMostarNuevoModal(false)
    },
    [dispatch]
  )

  const submitEditar = React.useCallback(
    (_idFila, data) => {
      dispatch({
        type: 'actualizar',
        payload: {
          _idFila: _idFila,
          ...data
        }
      })
      setMostarEditarModal(false)
    },
    [dispatch]
  )

  return (
    <>
      <Row className='mb-2'>
        <Col md={12} className='text-right'>
          <Button onClick={clickNuevo} tiny>
            Agregar Detalle
          </Button>
        </Col>
      </Row>
      <Table
        containerId='container-detallesnuevoasiento'
        filas={detalles}
        tablaDetalle
        headRows={tableHeaderRows}
        rowTemplate={tableRowTemplate}
      />
      {mostrarNuevoModal && (
        <Modals.NuevoModal
          show={mostrarNuevoModal}
          handleClose={e => setMostarNuevoModal(false)}
          submitFunction={submitNuevo}
        />
      )}
      {mostrarEditarModal && (
        <Modals.EditarModal
          show={mostrarEditarModal}
          handleClose={e => setMostarEditarModal(false)}
          submitFunction={submitEditar}
          modalData={editarModalDataRef.current}
        />
      )}
    </>
  )
}

export default React.memo(DetallesSection)
